<template lang="pug">
.contacts-table
	.contacts-table__sorter
		label.contacts-table__sorter-label Sort By:
		button.contacts-table__sorter-item(
			@click="sort('firstName')",
			:class="{ [currentSortDir]: currentSort === 'firstName' }"
		)
			span First Name
		button.contacts-table__sorter-item(
			@click="sort('lastName')",
			:class="{ [currentSortDir]: currentSort === 'lastName' }"
		)
			span Last Name
		button.contacts-table__sorter-item(
			@click="sort('positionTitle')",
			:class="{ [currentSortDir]: currentSort === 'positionTitle' }"
		)
			span Role
		button.contacts-table__sorter-item(
			@click="sort('service')",
			:class="{ [currentSortDir]: currentSort === 'service' }"
		)
			span Service
		button.contacts-table__sorter-item(
			@click="sort('phoneNumber')",
			:class="{ [currentSortDir]: currentSort === 'phoneNumber' }"
		)
			span Phone
		button.contacts-table__sorter-item(
			@click="sort('emailAddress')",
			:class="{ [currentSortDir]: currentSort === 'emailAddress' }"
		)
			span Email
	table.contacts-table__table.table
		thead.contacts-table__head
			tr.contacts-table__row
				th.contacts-table__cell(v-if="contactsHaveHeadshots")
					span 
				th.contacts-table__cell.sortable(
					@click="sort('firstName')",
					:class="{ [currentSortDir]: currentSort === 'firstName' }"
				) 
					span First Name
				th.contacts-table__cell.sortable(
					@click="sort('lastName')",
					:class="{ [currentSortDir]: currentSort === 'lastName' }"
				) 
					span Last Name
				th.contacts-table__cell.sortable(
					@click="sort('positionTitle')",
					:class="{ [currentSortDir]: currentSort === 'positionTitle' }"
				)
					span Role
				th.contacts-table__cell.sortable(
					@click="sort('serviceName')",
					:class="{ [currentSortDir]: currentSort === 'serviceName' }"
				)
					span Service
				th.contacts-table__cell.sortable(
					@click="sort('phoneNumber')",
					:class="{ [currentSortDir]: currentSort === 'phoneNumber' }"
				)
					span Phone
				th.contacts-table__cell.sortable(
					@click="sort('emailAddress')",
					:class="{ [currentSortDir]: currentSort === 'emailAddress' }"
				)
					span Email

		tbody.contacts-table__body
			tr.contacts-table__row(
				v-for="contact in sortedContacts"
			)
				td.contacts-table__cell.desktop(v-if="contactsHaveHeadshots")
					span
						img.contacts-table__headshot(v-if="contact.headshot", :src="contact.headshot", :alt="contact.firstName + ' ' + contact.lastName")
				td.contacts-table__cell(data-heading="First Name")
					span {{ contact.firstName }}
				td.contacts-table__cell(data-heading="Last Name")
					span {{ contact.lastName }}
				td.contacts-table__cell(data-heading="Role")
					span {{ contact.positionTitle }}
				td.contacts-table__cell(data-heading="Service", :class="{  }")
					span {{ contact.serviceName }}
				td.contacts-table__cell(data-heading="Phone")
					span 
						a(
							:href="'tel:' + contact.phoneNumber", 
							:aria-label="'Call ' + contact.firstName + ' ' + contact.lastName"
						) {{ contact.phoneNumber }}
				td.contacts-table__cell(data-heading="Email")
					span 
						a(
							:href="'mailto:' + contact.emailAddress", 
							:aria-label="'Send an email to ' + contact.firstName + ' ' + contact.lastName"
						) {{ contact.emailAddress }}
</template>

<script>
export default {
	name: "Table",
	props: {
		contacts: Array
	},
	computed: {
    sortedContacts() {
      return this.contacts
        .sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "descending") modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
    },
		contactsHaveHeadshots() {
			return this.contacts.some(c => !!c.headshot);
		},
	},
	data() {
		return {
			currentSort: this.$root.sortProperty || "serviceName",
			currentSortDir: this.$root.sortOrder || "ascending",
		};
	},
	methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "ascending" ? "descending" : "ascending";
      }
      this.currentSort = s;
      this.currentPage = 1;
    },
	},
	created() {},
};
</script>

<style scoped lang="scss">
.contacts-table {
	font-family: $fontFamilyBaseRM;
	width: 100%;
	&__sorter {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem 1rem;
    margin: 0 0 2rem;

    &-label {
      font-weight: 700;
      text-transform: uppercase;
    }
    &-item {
      all: unset;
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto auto;
      cursor: pointer;
      gap: 0.25rem 0.5rem;
      padding: 0.5rem;
      margin: 0;
      color: $white;
      background: $redRmf;
      transition: 0.25s ease all;
      span {
        grid-area: 1 / 1 / 3 / 2;
        align-self: center;
        line-height: 1;
      }
      &:hover {
        background: $darkBlueRmf;
      }
      &::before,
      &::after {
        all: unset;
        content: "";
        height: 0;
        width: 0;
        transition: 0.25s ease all;
        border-left: 0.25rem solid transparent;
        border-right: 0.25rem solid transparent;
        justify-self: start;
        opacity: 0.25;
      }
      &::before {
        border-bottom: 0.3875rem solid $white;
        grid-area: 1 / 2 / 2 / 3;
      }
      &::after {
        border-top: 0.3875rem solid $white;
        grid-area: 2 / 2 / 3 / 3;
      }
      &.ascending {
        &::before {
          opacity: 1;
        }
      }
      &.descending {
        &::after {
          opacity: 1;
        }
      }
    }
    @include mq(lg) {
      display: none;
    }
  }
	&__head {
		display: none;

		@include mq(lg) {
			display: revert;

			.contacts-tabl__row {
				vertical-align: middle;
			}
		}

		.contacts-table__cell {
			&.sortable {
				cursor: pointer;
				transition: 0.25s ease all;
				&:hover {
					background: $redRmf;
					color: $white;
					& > span::before,
					& > span::after {
						background: $white;
					}
				}
				&.ascending {
					& > span::before {
						opacity: 1;
					}
				}
				&.descending {
					& > span::after {
						opacity: 1;
					}
				}
				& > span {
					position: relative;
					&::before,
					&::after {
						content: "";
						height: 0.375rem;
						width: 0.5rem;
						position: absolute;
						background: $gray;
						right: -0.875rem;
						opacity: 0.25;
					}
					&::before {
						clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
						top: calc(50% - 0.5rem);
					}
					&::after {
						clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
						bottom: calc(50% - 0.5rem);
					}
				}
			} 
		}
	}
	&__body {
		display: flex;
		flex-direction: column;
		.contacts-table__row {
			&:nth-child(2n - 1) {
				background: $lightestGray;
			}
		}
		.contacts-table__cell {
			vertical-align: middle;
			&:before {
				content: attr(data-heading) ':';
				flex: 0 0 0;
				font-weight: 700;
				padding-right: 20px;
				white-space: nowrap;
				text-transform: uppercase;
			}
		}
		&[onclick] {
				cursor: pointer;
			}
			@include mq(lg) {
				transition: background-color 0.3s;
				display: revert;
				.contacts-table__cell {
					&:before {
						content: unset;
					}
				}
			}
	}
	&__row {
		display: flex;
		flex-direction: column;
		position: relative;

		@include mq(lg) {
			display: revert;
			margin-bottom: 0;
		}
	}
	&__cell {
		position: relative;
		transition: background-color 0.2s;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		text-align: left;

		&.desktop {
			display: none;
			@include mq(lg) {
				display: revert;
			}
		}
		& > span {
			margin-left: auto;
		}

		@include mq(sm) {
			flex: 1 1 0;
		}

		@include mq(lg) {
			display: revert;

			& > span {
				margin-left: 0;
			}
		}
	}
	&__headshot {
		width: 60px;
		height: 60px;
		min-width: 60px;
		min-height: 60px;
		object-fit: cover;
		border-radius: 50%;
	}
}
</style>